import { View } from "dripsy";
import React from "react";
import { space } from "../baseTheme/styles/spacings";

type SpaceScale = keyof typeof space;
export interface SpaceProps {
  height?: SpaceScale;
  width?: SpaceScale;
}

export const Space: React.FC<SpaceProps> = (props) => {
  const { height, width } = props;
  return (
    <View
      sx={{
        height: height || 1,
        width: width || "100%",
      }}
    />
  );
};
